import React from 'react'
import { FiDownload } from 'react-icons/fi'

const BillingManagement: React.FC = () => {
  // const bookings = [
  //   {
  //     bookingId: 'BK-001',
  //     patientName: 'John Doe',
  //     therapistName: 'Dr. Emily Ross',
  //     serviceType: 'Physiotherapy',
  //     bookingDate: '25/09/2025',
  //     appointmentDateTime: '28/09/2025 10:00 AM',
  //     sessionFee: 100,
  //     adminCommissionPercent: 10,
  //     adminCommissionAmount: 10,
  //     paymentStatus: 'Paid',
  //     status: 'Completed',
  //     invoiceLink: '#',
  //   },
  //   {
  //     bookingId: 'BK-002',
  //     patientName: 'Jane Smith',
  //     therapistName: 'Dr. Mark Wilson',
  //     serviceType: 'Occupational Therapy',
  //     bookingDate: '26/09/2025',
  //     appointmentDateTime: '29/09/2025 11:30 AM',
  //     sessionFee: 120,
  //     adminCommissionPercent: 12,
  //     adminCommissionAmount: 14,
  //     paymentStatus: 'Pending',
  //     status: 'Upcoming',
  //     invoiceLink: '#',
  //   },
  //   {
  //     bookingId: 'BK-003',
  //     patientName: 'Alice Brown',
  //     therapistName: 'Dr. Sarah Lee',
  //     serviceType: 'Speech Therapy',
  //     bookingDate: '27/09/2025',
  //     appointmentDateTime: '30/09/2025 02:00 PM',
  //     sessionFee: 90,
  //     adminCommissionPercent: 15,
  //     adminCommissionAmount: 13,
  //     paymentStatus: 'Paid',
  //     status: 'Completed',
  //     invoiceLink: '#',
  //   },
  //   {
  //     bookingId: 'BK-004',
  //     patientName: 'Bob Johnson',
  //     therapistName: 'Dr. Kevin White',
  //     serviceType: 'Physiotherapy',
  //     bookingDate: '28/09/2025',
  //     appointmentDateTime: '01/10/2025 09:00 AM',
  //     sessionFee: 110,
  //     adminCommissionPercent: 10,
  //     adminCommissionAmount: 11,
  //     paymentStatus: 'Paid',
  //     status: 'Completed',
  //     invoiceLink: '#',
  //   },
  //   {
  //     bookingId: 'BK-005',
  //     patientName: 'Emma Davis',
  //     therapistName: 'Dr. Olivia Green',
  //     serviceType: 'Occupational Therapy',
  //     bookingDate: '29/09/2025',
  //     appointmentDateTime: '02/10/2025 01:00 PM',
  //     sessionFee: 130,
  //     adminCommissionPercent: 12,
  //     adminCommissionAmount: 15,
  //     paymentStatus: 'Pending',
  //     status: 'Upcoming',
  //     invoiceLink: '#',
  //   },
  // ]
  const bookings = [
    {
      sessionId: 'S001',
      contractNumber: 'CN-1001',
      bookingId: 'BK-001',
      patientName: 'John Doe',
      therapistName: 'Dr. Emily Ross',
      serviceType: 'Physiotherapy',
      bookingDate: '25/09/2025',
      appointmentDateTime: '28/09/2025 10:00 AM',
      sessionFee: 100,
      adminCommissionPercent: 10,
      adminCommissionAmount: 10,
      paymentStatus: 'Paid',
      status: 'Completed',
      invoiceLink: '#',
      paymentType: 'Card',
    },
    {
      sessionId: 'S002',
      contractNumber: 'CN-1001',
      bookingId: 'BK-002',
      patientName: 'John Doe',
      therapistName: 'Dr. Emily Ross',
      serviceType: 'Physiotherapy',
      bookingDate: '26/09/2025',
      appointmentDateTime: '29/09/2025 11:00 AM',
      sessionFee: 100,
      adminCommissionPercent: 10,
      adminCommissionAmount: 10,
      paymentStatus: 'Paid',
      status: 'Upcoming',
      invoiceLink: '#',
      paymentType: 'Card',
    },
    {
      sessionId: 'S003',
      contractNumber: 'CN-2002',
      bookingId: 'BK-003',
      patientName: 'Jane Smith',
      therapistName: 'Dr. Mark Wilson',
      serviceType: 'Occupational Therapy',
      bookingDate: '26/09/2025',
      appointmentDateTime: '29/09/2025 11:30 AM',
      sessionFee: 120,
      adminCommissionPercent: 5,
      adminCommissionAmount: 14,
      paymentStatus: 'Pending',
      status: 'Upcoming',
      invoiceLink: '#',
      paymentType: 'Insurance',
    },
    {
      sessionId: 'S004',
      contractNumber: 'CN-3003',
      bookingId: 'BK-004',
      patientName: 'Alice Brown',
      therapistName: 'Dr. Sarah Lee',
      serviceType: 'Speech Therapy',
      bookingDate: '27/09/2025',
      appointmentDateTime: '30/09/2025 02:00 PM',
      sessionFee: 90,
      adminCommissionPercent: 5,
      adminCommissionAmount: 13,
      paymentStatus: 'Paid',
      status: 'Completed',
      invoiceLink: '#',
      paymentType: 'Card',
    },
    {
      sessionId: 'S005',
      contractNumber: 'CN-4004',
      bookingId: 'BK-005',
      patientName: 'Bob Johnson',
      therapistName: 'Dr. Kevin White',
      serviceType: 'Physiotherapy',
      bookingDate: '28/09/2025',
      appointmentDateTime: '01/10/2025 09:00 AM',
      sessionFee: 110,
      adminCommissionPercent: 10,
      adminCommissionAmount: 11,
      paymentStatus: 'Paid',
      status: 'Completed',
      invoiceLink: '#',
      paymentType: 'Insurance',
    },
    {
      sessionId: 'S006',
      contractNumber: 'CN-4004',
      bookingId: 'BK-006',
      patientName: 'Bob Johnson',
      therapistName: 'Dr. Kevin White',
      serviceType: 'Physiotherapy',
      bookingDate: '29/09/2025',
      appointmentDateTime: '02/10/2025 09:00 AM',
      sessionFee: 110,
      adminCommissionPercent: 10,
      adminCommissionAmount: 11,
      paymentStatus: 'Paid',
      status: 'Upcoming',
      invoiceLink: '#',
      paymentType: 'Card',
    },
    {
      sessionId: 'S007',
      contractNumber: 'CN-5005',
      bookingId: 'BK-007',
      patientName: 'Emma Davis',
      therapistName: 'Dr. Olivia Green',
      serviceType: 'Occupational Therapy',
      bookingDate: '29/09/2025',
      appointmentDateTime: '02/10/2025 01:00 PM',
      sessionFee: 130,
      adminCommissionPercent: 10,
      adminCommissionAmount: 15,
      paymentStatus: 'Pending',
      status: 'Upcoming',
      invoiceLink: '#',
      paymentType: 'Insurance',
    },
  ]

  return (
    <div className="p-6 mx-auto max-w-7xl">
      {/* Header & Filters */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6 gap-4">
        <h1 className="text-2xl font-semibold text-[#026730]">Revenue</h1>

        <div className="ml-auto">
          <button className="flex items-center gap-2 px-4 py-2 h-12 text-gray-700 transition-colors border border-gray-300 rounded-lg hover:bg-gray-50">
            <FiDownload className="w-4 h-4" />
            Export CSV
          </button>
        </div>
      </div>

      <div className="flex flex-nowrap items-center gap-3 overflow-x-auto pb-2">
        <input
          type="text"
          placeholder="Contract ID"
          className="w-[180px] h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
        />
        <input
          type="text"
          placeholder="Session ID"
          className="w-[180px] h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
        />
        <input
          type="text"
          placeholder="Patient Name"
          className="w-[150px] h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
        />
        <input
          type="text"
          placeholder="Provider Name"
          className="w-[150px] h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
        />
        <select className="w-[150px] h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
          <option value="">Status</option>
          <option value="Paid">Paid</option>
          <option value="Pending">Pending</option>
        </select>
        <input
          type="date"
          className="w-[150px] h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
        />
        <input
          type="date"
          className="w-[150px] h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
        />
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mb-6">
        {/* Total Bookings */}
        <div className="p-4 bg-white rounded-lg shadow flex items-center justify-between h-35">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">800</h2>
            <p className="text-sm text-gray-500">Total Contracts</p>
          </div>
          <div className="bg-gray-100 text-gray-600 rounded-full w-12 h-12 flex items-center justify-center text-xl font-bold">
            💳
          </div>
        </div>

        {/* Paid */}
        <div className="p-4 bg-white rounded-lg shadow flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">2456</h2>
            <p className="text-sm text-gray-500">Total Session</p>
          </div>
          <div className="bg-green-100 text-green-600 rounded-full w-12 h-12 flex items-center justify-center text-xl font-bold">
            ✅
          </div>
        </div>

        {/* Pending */}
        <div className="p-4 bg-white rounded-lg shadow flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">$ 325412.00</h2>
            <p className="text-sm text-gray-500">Total Revenue</p>
          </div>
          <div className="bg-yellow-100 text-yellow-600 rounded-full w-12 h-12 flex items-center justify-center text-xl font-bold">
            ⏳
          </div>
        </div>

        {/* Total Therapist Earnings */}
        <div className="p-4 bg-white rounded-lg shadow flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">$ 258523.00</h2>
            <p className="text-sm text-gray-500">Total Commission</p>
          </div>
          <div className="bg-blue-100 text-blue-600 rounded-full w-12 h-12 flex items-center justify-center text-xl font-bold">
            💰
          </div>
        </div>
      </div>

      {/* Bookings Table */}
      <div className="overflow-hidden bg-white rounded-lg shadow">
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead className="bg-gray-50">
              <tr className="text-sm text-left text-gray-600 uppercase">
                <th className="px-6 py-3 font-medium">Contract ID</th>
                <th className="px-6 py-3 font-medium">Session ID</th>
                <th className="px-6 py-3 font-medium">Patient Name</th>
                <th className="px-6 py-3 font-medium">Provider Name</th>
                <th className="px-6 py-3 font-medium">Service Type</th>
                <th className="px-6 py-3 font-medium">Payment Method</th>
                {/* <th className="px-6 py-3 font-medium">Booking Date</th> */}
                <th className="px-6 py-3 font-medium">Session Date & Time</th>
                <th className="px-6 py-3 font-medium">Session Fee</th>
                <th className="px-6 py-3 font-medium">
                  Platform Commission (%)
                </th>
                <th className="px-6 py-3 font-medium">Platform Commission</th>
                <th className="px-6 py-3 font-medium">
                  Provider Earnings
                </th>{' '}
                {/* New */}
                <th className="px-6 py-3 font-medium">Payment Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {bookings.map(b => (
                <tr
                  key={b.bookingId}
                  className="transition-colors hover:bg-gray-50"
                >
                  <td className="px-6 py-4">{b.contractNumber}</td>
                  <td className="px-6 py-4">{b.sessionId}</td>
                  <td className="px-6 py-4">{b.patientName}</td>
                  <td className="px-6 py-4">{b.therapistName}</td>
                  <td className="px-6 py-4">{b.serviceType}</td>
                  <td className="px-6 py-4">{b.paymentType}</td>
                  {/* <td className="px-6 py-4">{b.bookingDate}</td> */}
                  <td className="px-6 py-4">{b.appointmentDateTime}</td>
                  <td className="px-6 py-4">${b.sessionFee}.00</td>
                  <td className="px-6 py-4">{b.adminCommissionPercent}%</td>
                  <td className="px-6 py-4">${b.adminCommissionAmount}.00</td>
                  <td className="px-6 py-4">
                    <span className="font-medium">
                      ${b.sessionFee - b.adminCommissionAmount}.00
                    </span>{' '}
                    {/* New */}
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium border ${
                        b.paymentStatus === 'Paid'
                          ? 'border-green-500 text-green-600'
                          : 'border-yellow-500 text-yellow-600'
                      }`}
                    >
                      {b.paymentStatus}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default BillingManagement
